var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4Wheels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8405 25.7269H6.06905C5.45842 25.7269 4.96484 25.2012 4.96484 24.5508V10.4378C4.96484 9.78743 5.45842 9.26172 6.06905 9.26172H23.7363C24.347 9.26172 24.8405 9.78743 24.8405 10.4378V25.7269Z",
    fill: "#0098FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0783 29.124H31.7227",
    stroke: "#2D2D2D",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5229 41.2715H20.916",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3426 23.4726L39.0489 13.582C38.755 12.9165 38.0995 12.4883 37.3755 12.4883H32.1463C31.6677 12.4883 31.2793 12.879 31.2793 13.3605V23.8267C31.2793 24.3082 31.6677 24.6989 32.1463 24.6989H42.5501C43.177 24.6989 43.5975 24.0491 43.3426 23.4726V23.4726Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0151 41.2773L5.31041 41.271C4.8318 41.271 4.44336 40.8802 4.44336 40.3988V9.87219C4.44336 9.39074 4.8318 9 5.31041 9H38.2861C40.38 9 42.2771 10.2403 43.1277 12.1652L48.6144 24.5886C48.6473 24.6619 48.6898 24.7308 48.741 24.7927L52.7979 29.6901C52.928 29.847 52.999 30.0442 52.999 30.2483V40.3988C52.999 40.8802 52.6106 41.271 52.132 41.271H47.4282",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.716 46.5043C18.5891 46.5043 20.9183 44.1614 20.9183 41.2712C20.9183 38.381 18.5891 36.0381 15.716 36.0381C12.8428 36.0381 10.5137 38.381 10.5137 41.2712C10.5137 44.1614 12.8428 46.5043 15.716 46.5043Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7238 46.5043C44.5969 46.5043 46.9261 44.1614 46.9261 41.2712C46.9261 38.381 44.5969 36.0381 41.7238 36.0381C38.8506 36.0381 36.5215 38.381 36.5215 41.2712C36.5215 44.1614 38.8506 46.5043 41.7238 46.5043Z",
    stroke: "#2D2D2D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9402 29.9326H48.6639C48.1853 29.9326 47.7969 30.3234 47.7969 30.8048V32.5492C47.7969 33.0306 48.1853 33.4214 48.6639 33.4214H52.9992",
    stroke: "#2D2D2D",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8398 9.26172L24.8398 25.7269",
    stroke: "#2D2D2D",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8405 25.7266H4.96484",
    stroke: "#2D2D2D",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5997 47H4.75391",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7521 39.0615C43.9213 39.6496 44.5059 40.5904 44.5059 42.0017",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50748 44.9414H3",
    stroke: "#2D2D2D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9313 41.6259C13.133 42.9251 13.8465 43.7712 15.1831 44.2001",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Wheels);
export default __webpack_public_path__ + "static/media/4_wheels.d0e01b07355b76f91a5bdfe2f5869ab5.svg";
export { ForwardRef as ReactComponent };